import { WalletMockService } from "@/services/backend";
import { Button } from "@mantine/core";
import { CheckoutRequest } from "..";
import { randomUUID } from "crypto";
import { useNavigate } from "react-router-dom";

export function TestCheckoutPage(){
    const navigate = useNavigate();
    async function goToCheckout(){
        const request : CheckoutRequest = {
            merchant: "bestbuy.com",
            preid: "testproductid1",
            subtotal: "79.99",
            shipping: "0.00",
            tax: "0.00",
            total: "79.99",
            desc: "test product",
            callback: "",
            cid: "",
            productUrl: "https://www.bestbuy.com/product/jlab-jbuds-lux-anc-headphones-graphite/J3GW8XZR73/sku/6580402",
            items: [{id: "6580398", amount:"79.99", name:"Jlab lux headphones", url:"", quantity:1, merchant: "bestbuy.com"}, {id:"6616036",amount:"69.99", name:"Seagate - Barracuda 4TB Internal Hard Drive for Desktops", quantity: 1, url:"https://www.bestbuy.com/product/seagate-barracuda-4tb-internal-hard-drive-for-desktops/J37C5HK32Z/sku/6616037", merchant:"bestbuy.com"}]
        } 
        const id = await WalletMockService.checkout(request);
        navigate(`/checkout/${id}`);
    }
    return (
        <>
            <Button onClick={goToCheckout}>Go To Checkout</Button>
        </>
    )
}